import { render, staticRenderFns } from "./PracticalTrainManage.vue?vue&type=template&id=16d4661f&scoped=true"
import script from "./PracticalTrainManage.vue?vue&type=script&lang=js"
export * from "./PracticalTrainManage.vue?vue&type=script&lang=js"
import style0 from "./PracticalTrainManage.vue?vue&type=style&index=0&id=16d4661f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4661f",
  null
  
)

export default component.exports